import {Component, h} from 'preact'
import GroupDescription from './GroupDescription'
import Axios from 'axios'
import GroupActionButtons from './GroupActionButtons'
import PrivateGroupPlaceholder from './PrivateGroupPlaceholder'
import GroupMembers from './GroupMembers'
import TopicListItemView, {TopicInfo} from '../topic-list-view/TopicListItemView'
import TopicListItem from '../topic-list-view/TopicListItem'
import {common} from '../common'
import {UserData} from '../event/EventAttendees'
import FeaturedTopicsWidget from '../widget-featured-topics/index'

export interface GroupData {
  id: number,
  title: string,
  description: string,
  groupType: number,
  curatedContent: {
    curatedTopics: Array<{id: number, type: string}>,
    title: string
  }
}

interface Props {
  group: GroupData,
  csrfToken: string,
  topics: Array<TopicInfo>,
  attachmentCdn: string,
  isGuest: boolean,
  members: Array<UserData>,
  isCurrentUserMember: boolean,
  membershipStatus: string
}

interface State {
  userJoined: boolean,
  isLoading: boolean,
  requestSent: boolean
}

export class Group extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      userJoined: props.isCurrentUserMember,
      isLoading: false,
      requestSent: props.membershipStatus == 'requested',
    }

    this.joinGroup = this.joinGroup.bind(this)
    this.leaveGroup = this.leaveGroup.bind(this)
    this.requestJoin = this.requestJoin.bind(this)
  }

  async joinGroup(onSucess?: Function) {
    if (!window.inSidedData.user.userid) {
      const event = new window.CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    this.setState({isLoading: true})

    try {
      await Axios.post(`/group/${this.props.group.id}/join`, {csrfToken: this.props.csrfToken})
      this.setState({userJoined: this.props.group.groupType === 4, isLoading: false})
      if (onSucess) {
        onSucess()
      }
    } catch (e) {
      this.setState({isLoading: false})
    }
  }

  async leaveGroup() {
    this.setState({isLoading: true})

    try {
      await Axios.post(`/group/${this.props.group.id}/leave`, {csrfToken: this.props.csrfToken})
      this.setState({userJoined: false, isLoading: false})
    } catch (e) {
      this.setState({isLoading: false})
    }
  }

  async requestJoin() {
    this.joinGroup(() => {
      this.setState({requestSent: true})
    })
  }
  render({group, topics, isGuest, attachmentCdn, members}: Props, {userJoined, isLoading, requestSent}: State) {
    const {description} = group
    const isNewTopicListViewEnabled = common.isModuleActive('topicItemView')
    const isPrivateGroup = group.groupType === 5

    return (
      <div className='group-detail-wrapper'>
        {(userJoined || !isPrivateGroup) &&
          <div className='group-featured-topics-container'>
            <GroupActionButtons
              joinGroup={this.joinGroup}
              leaveGroup={this.leaveGroup}
              isLoading={isLoading}
              isUserMember={userJoined}
              groupId={group.id}
            />
            <FeaturedTopicsWidget
              title={group.curatedContent.title}
              topicsFullWidth={0}
              topicIds={group.curatedContent.curatedTopics}
            />
          </div>
        }
        <div className='sitewidth group-detail'>
          <div className='col col--main has--side qa-div-main'>
            <div className={`${isNewTopicListViewEnabled ? 'list-widget-wrapper' : 'box'}`}>
              {(userJoined || !isPrivateGroup) &&
                topics.map(topic => {
                  return isNewTopicListViewEnabled ? (
                    <TopicListItemView
                      topic={topic}
                      isGuest={isGuest}
                      attachmentCdn={attachmentCdn}
                      hideCategoryMetadata
                    />
                  ) : (
                    <TopicListItem
                      tab={0}
                      topic={topic}
                      isGuest={isGuest}
                      attachmentCdn={attachmentCdn}
                      hideCategoryMetadata
                    />
                  )
                })}
              {isPrivateGroup && !userJoined &&
                <PrivateGroupPlaceholder
                  onRequest={this.requestJoin}
                  isLoading={isLoading}
                  requestPending={requestSent}
                />
              }
            </div>
          </div>
          <div className='col col--side Sidebarmodule qa-div-sidebar'>
            <GroupDescription description={description} />
            {(userJoined || !isPrivateGroup) &&
              <GroupMembers members={members} />
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Group
